import React, { Component } from 'react';

import { FEATURE_FLAG } from '@qality/common-config';
import { IssueService } from '@qality/common-service';

import AddToTestCycleDialog from './AddToTestCycleDialog';

type Props = {
  onClose: () => void;
  testCaseIds: Array<number>;
};

type State = {
  projectId: string;
};

export default class AddToTestCycleDialogWrapper extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      projectId: null,
    };
  }

  onClose = (): void => {
    this.props.onClose();
  };

  async componentDidMount(): Promise<void> {
    // projectId is used only in QAlity Free where there's no bulk test case add
    // so it always will be the 1st value
    const issue = !FEATURE_FLAG.isPremium
      ? await IssueService.getIssue(String(this.props.testCaseIds[0]))
      : null;

    this.setState({
      projectId: String(issue?.fields.project.id),
    });
  }

  render(): React.ReactNode {
    return (
      <>
        {this.state.projectId && (
          <AddToTestCycleDialog
            projectId={this.state.projectId}
            testCaseIds={this.props.testCaseIds}
            onClose={this.onClose}
          />
        )}
      </>
    );
  }
}
